module.exports = __webpack_public_path__ + "static/media/home-at-night.f35546b1.jpg";